import {StatusLayerType} from '../settings.service';
import {TrackStyles} from './TrackStyles';

export class LayerTypeFilter {
  filterName: string;
  measurement: string;
  measurementUnits?: FilterSetting[];

  static coverageLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.COVERAGE,
      measurement: 'Passes',
      measurementUnits: [
        {
          number: '1',
          color: trackStyles.roadStatusCoverageLevel1.color,
          dashArray: trackStyles.roadStatusCoverageLevel1.dasharray,
        },
        {
          number: '2-4',
          color: trackStyles.roadStatusCoverageLevel2.color,
          dashArray: trackStyles.roadStatusCoverageLevel2.dasharray,
        },
        {
          number: '5-7',
          color: trackStyles.roadStatusCoverageLevel3.color,
          dashArray: trackStyles.roadStatusCoverageLevel3.dasharray,
        },
        {
          number: '8-10',
          color: trackStyles.roadStatusCoverageLevel4.color,
          dashArray: trackStyles.roadStatusCoverageLevel4.dasharray,
        },
        {
          number: '10+',
          color: trackStyles.roadStatusCoverageLevel5.color,
          dashArray: trackStyles.roadStatusCoverageLevel5.dasharray,
        },
      ],
    };
  }

  static currencyLayerTypeFilter(trackStyles: TrackStyles, timeUnit: number): LayerTypeFilter {
    return {
      filterName: StatusLayerType.CURRENCY,
      measurement: 'Time',
      measurementUnits: [
        {
          number: `< ${timeUnit} hr`,
          color: trackStyles.roadStatusCurrencyLevel1.color,
          dashArray: trackStyles.roadStatusCurrencyLevel1.dasharray,
        },
        {
          number: `${timeUnit}-${timeUnit * 2} hr`,
          color: trackStyles.roadStatusCurrencyLevel2.color,
          dashArray: trackStyles.roadStatusCurrencyLevel2.dasharray,
        },
        {
          number: `${timeUnit * 2}-${timeUnit * 3} hr`,
          color: trackStyles.roadStatusCurrencyLevel3.color,
          dashArray: trackStyles.roadStatusCurrencyLevel3.dasharray,
        },
        {
          number: `${timeUnit * 3}-${timeUnit * 4} hr`,
          color: trackStyles.roadStatusCurrencyLevel4.color,
          dashArray: trackStyles.roadStatusCurrencyLevel4.dasharray,
        },
        {
          number: `${timeUnit * 4}-${timeUnit * 12} hr`,
          color: trackStyles.roadStatusCurrencyLevel5.color,
          dashArray: trackStyles.roadStatusCurrencyLevel5.dasharray,
        },
      ],
    };
  }

  static gpsTracksLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.GPS_TRACKS,
      measurement: '',
      measurementUnits: [
        {
          number: 'Active',
          color: trackStyles.liveMapPlowLive.color,
          dashArray: trackStyles.liveMapPlowLive.dasharray,
        },
        {
          number: 'Recent',
          color: trackStyles.liveMapPlowInactive.color,
          dashArray: trackStyles.liveMapPlowInactive.dasharray,
        },
      ],
    };
  }

  static routeStatusLayerTypeFilter(trackStyles: TrackStyles): LayerTypeFilter {
    return {
      filterName: StatusLayerType.ROUTE_STATUS,
      measurement: '',
      measurementUnits: [
        {
          number: 'Serviced',
          color: trackStyles.routeStatusServiced.color,
          dashArray: trackStyles.routeStatusServiced.dasharray,
        },
        {
          number: 'In Progress',
          color: trackStyles.routeStatusInProgress.color,
          dashArray: trackStyles.routeStatusInProgress.dasharray,
        },
        {
          number: 'Not Serviced',
          color: trackStyles.routeStatusNotServiced.color,
          dashArray: trackStyles.routeStatusNotServiced.dasharray,
        },
      ],
    };
  }

  static copy(legendSettings: LayerTypeFilter): LayerTypeFilter {
    return JSON.parse(JSON.stringify(legendSettings));
  }
}

export interface FilterSetting {
  number: string;
  color: string;
  dashArray: number[];
}
